import { render } from "./PdrsDetail.vue?vue&type=template&id=5040f9d7"
import script from "./PdrsDetail.vue?vue&type=script&lang=js"
export * from "./PdrsDetail.vue?vue&type=script&lang=js"

import "./PdrsDetail.vue?vue&type=style&index=0&id=5040f9d7&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__